import { render, staticRenderFns } from "./WhoAmI.vue?vue&type=template&id=9ca69fe6&scoped=true&"
import script from "./WhoAmI.vue?vue&type=script&lang=js&"
export * from "./WhoAmI.vue?vue&type=script&lang=js&"
import style0 from "./WhoAmI.vue?vue&type=style&index=0&id=9ca69fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca69fe6",
  null
  
)

export default component.exports